import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { MapPin, Phone, Clock, ArrowRight } from "lucide-react";

export default function BranchDetail() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  useEffect(() => { api.get(`/branches/${slug}`).then((r) => setB(r.data)).catch(() => {}); }, [slug]);
  if (!b) return <div className="p-20 text-hsecondary text-center">Loading...</div>;

  return (
    <div data-testid="branch-detail-page">
      <section className="relative h-[70vh] overflow-hidden">
        <img src={b.hero_image} alt={b.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-transparent" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 h-full flex flex-col justify-end pb-16">
          <div className="label-eyebrow mb-4">{b.city}</div>
          <h1 className="text-5xl lg:text-7xl font-heading text-white">{b.name}</h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 lg:grid-cols-3 gap-12">
        <div className="lg:col-span-2">
          <div className="label-eyebrow mb-3">About this branch</div>
          <p className="text-hsecondary text-lg leading-relaxed">{b.description}</p>

          <div className="mt-10">
            <div className="label-eyebrow mb-3">Facilities</div>
            <div className="flex flex-wrap gap-2">
              {b.facilities?.map((f, i) => (
                <span key={i} className="border border-white/10 px-3 py-1.5 text-xs uppercase tracking-widest text-white/70">{f}</span>
              ))}
            </div>
          </div>

          <div className="mt-10">
            <div className="label-eyebrow mb-3">Gallery</div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
              {b.gallery?.map((g, i) => (
                <img key={i} src={g} alt="" className="aspect-square object-cover w-full" />
              ))}
            </div>
          </div>
        </div>

        <aside className="border border-white/10 p-8 h-fit sticky top-32">
          <div className="label-eyebrow mb-4">Reach us</div>
          <div className="space-y-4 text-sm text-hsecondary">
            <div className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 text-hgold shrink-0" />{b.address}</div>
            <div className="flex items-center gap-3"><Phone size={16} className="text-hgold shrink-0" />{b.phone}</div>
            <div className="flex items-center gap-3"><Clock size={16} className="text-hgold shrink-0" />{b.hours}</div>
          </div>
          {b.map_url && (
            <a href={b.map_url} target="_blank" rel="noreferrer" className="ghost-btn mt-6 w-full justify-center">Open in Maps</a>
          )}
          <Link to={`/book?branch=${b.id}`} className="gold-btn mt-3 w-full justify-center" data-testid="branch-book-cta">
            Book at {b.name.split(" ").slice(-2).join(" ")} <ArrowRight size={14}/>
          </Link>
        </aside>
      </section>
    </div>
  );
}
